import InspectionsPage from './InspectionsPage';

export default InspectionsPage;
